import * as React from "react";
import { withRouter } from "react-router-dom";
import { Col, FormGroup, Input, Label } from "reactstrap";
import nameof from "ts-nameof.macro";
import { ColegiosDropDown } from "../colegios/ColegiosDropDown";
import { CustomDatePicker } from "../helpers/CustomDatePicker";
import { EstadoPedidoScholarumDropDown } from "../helpers/EnumDropDown";
import { RouteHelper } from "../IntranetRouter";
import { EstadoPedidoScholarum, PedidoLineaTiendaListItem, PedidoLineaTiendaListItemPaginatedList, PedidosLineasTiendaSearch, SortDirection, TipoUsuario } from "../models/dataModels";
import { IServiceForIndex } from "../utils/base/BaseServices";
import { IndexPageBase, TableColumn } from "../utils/base/IndexPageBase";
import { ClientContext } from "../utils/ClientContext";
import { I18n } from "../utils/I18n";
import { toCamelCase } from "../utils/ValuesFormatter";
import { PedidosLineasTiendaService } from "./PedidosLineasTiendaService";


interface PedidosLineasTiendaSearchEx extends PedidosLineasTiendaSearch {
    colegio: string;
}

class IndexComp extends IndexPageBase<PedidosLineasTiendaSearchEx, PedidoLineaTiendaListItemPaginatedList, PedidoLineaTiendaListItem>
{

    protected _getInitialSearchParams(): PedidosLineasTiendaSearchEx {

        let model = super._getInitialSearchParams();

        // Mismo arranque que /pedidos-tienda: desde el inicio de campaña del curso activo.
        model.fechaCompraFrom = ClientContext.getCursoEscolarActivo().fechaInicioCampagna;
        model.orderMode = SortDirection.Desc;
        model.colegioId = ClientContext.Current.colegioId;
        model.colegio = ClientContext.Current.nombreColegio;
        return model;
    }

    protected _getApiService(): IServiceForIndex<PedidosLineasTiendaSearch, PedidoLineaTiendaListItemPaginatedList> {
        return new PedidosLineasTiendaService();
    }

    protected _enableExcelExport() {
        return true;
    }

    /**
     * El grid no borra líneas: el servicio no implementa delete.
     */
    protected deleteButtonOverride(item: PedidoLineaTiendaListItem): JSX.Element {
        return null;
    }

    protected _renderSearchForm(): React.ReactNode {

        if (this.props.isEmbedded) {
            return null;
        }

        return <React.Fragment>

            <Col xs="12" md="6" lg="3">
                <FormGroup>

                    <ColegiosDropDown
                        label={I18n.Strings.colegio.entityName}

                        onChanged={(colegioId, colegioNombre) => {

                            var state = this._cloneStateForSetState();
                            state.searchParams.colegioId = colegioId;
                            state.searchParams.colegio = colegioNombre;
                            this.setState(state);
                        }}
                        id={nameof(this.state.searchParams.colegioId)}
                        selectedItemValue={this.state.searchParams.colegioId || 0}
                        selectedItemText={this.state.searchParams.colegio || ""}
                        emptyText=""
                    />
                </FormGroup>
            </Col>

            <Col xs="12" md="6" lg="3">
                <FormGroup>
                    <Label for={nameof(this.state.searchParams.nombreCliente)}>
                        {I18n.Strings.pedidos.cliente}
                    </Label>
                    <Input
                        onChange={(evt) => {
                            var state = this._cloneStateForSetState();
                            state.searchParams.nombreCliente = evt.target.value;
                            this.setState(state);
                        }}
                        placeholder={I18n.Strings.pedidos.cliente + "..."}
                        type="text"
                        maxLength={100}
                        className={"form-control"}
                        name={nameof(this.state.searchParams.nombreCliente)}
                        id={nameof(this.state.searchParams.nombreCliente)}
                        value={this.state.searchParams.nombreCliente || ""}
                    />
                </FormGroup>
            </Col>

            <Col xs="12" md="6" lg="3">
                <FormGroup>
                    <Label for={nameof(this.state.searchParams.nombreEstudiante)}>
                        {I18n.Strings.pedidosLineas.estudiante}
                    </Label>
                    <Input
                        onChange={(evt) => {
                            var state = this._cloneStateForSetState();
                            state.searchParams.nombreEstudiante = evt.target.value;
                            this.setState(state);
                        }}
                        placeholder={I18n.Strings.pedidosLineas.estudiante + "..."}
                        type="text"
                        maxLength={100}
                        className={"form-control"}
                        name={nameof(this.state.searchParams.nombreEstudiante)}
                        id={nameof(this.state.searchParams.nombreEstudiante)}
                        value={this.state.searchParams.nombreEstudiante || ""}
                    />
                </FormGroup>
            </Col>

            <Col xs="12" md="6" lg="3">
                <FormGroup>
                    <Label for={nameof(this.state.searchParams.numPedido)}>
                        {I18n.Strings.pedidos.numPedido}
                    </Label>
                    <Input
                        onChange={(evt) => {
                            var state = this._cloneStateForSetState();
                            if (evt.target.value == "") {
                                state.searchParams.numPedido = null;
                            }
                            else {
                                state.searchParams.numPedido = parseInt(evt.target.value);
                            }

                            this.setState(state);
                        }}
                        placeholder={I18n.Strings.pedidos.numPedido + "..."}
                        type="number"
                        maxLength={100}
                        className={"form-control"}
                        name={nameof(this.state.searchParams.numPedido)}
                        id={"lineas" + nameof(this.state.searchParams.numPedido)}
                        value={this.state.searchParams.numPedido || ""}
                    />
                </FormGroup>
            </Col>

            <Col xs="12" md="6" lg="3">
                <FormGroup>
                    <Label for={nameof(this.state.searchParams.sku)}>
                        {I18n.Strings.pedidos.sku}
                    </Label>
                    <Input
                        onChange={(evt) => {
                            var state = this._cloneStateForSetState();
                            state.searchParams.sku = evt.target.value;
                            this.setState(state);
                        }}
                        placeholder={I18n.Strings.pedidos.sku + "..."}
                        type="text"
                        maxLength={100}
                        className={"form-control"}
                        name={nameof(this.state.searchParams.sku)}
                        id={"lineas" + nameof(this.state.searchParams.sku)}
                        value={this.state.searchParams.sku || ""}
                    />
                </FormGroup>
            </Col>

            <Col xs="12" md="6" lg="3">
                <FormGroup>
                    <Label for={nameof(this.state.searchParams.estadoPedidoScholarum)}>
                        {I18n.Strings.pedidos.estado}
                    </Label>
                    <EstadoPedidoScholarumDropDown
                        emptyText={I18n.Strings.pedidos.estado + "..."}
                        label={null}
                        id={nameof(this.state.searchParams.estadoPedidoScholarum)}
                        value={this.state.searchParams.estadoPedidoScholarum}
                        required={true}
                        errorMessage={null}
                        onChanged={(value: string) => {
                            var newState = this._cloneStateForSetState();
                            if (value != '') {
                                newState.searchParams.estadoPedidoScholarum = value as EstadoPedidoScholarum;
                            }
                            else {
                                newState.searchParams.estadoPedidoScholarum = null;
                            }
                            this.setState(newState, () => this._performSearch());
                        }}
                    />
                </FormGroup>
            </Col>

            <Col xs="12" md="6" lg="3">
                <FormGroup>
                    <Label for={nameof(this.state.searchParams.fechaCompraFrom)}>
                        {I18n.Strings.pedidos.fechaCompraFrom}
                    </Label>
                    <CustomDatePicker
                        key={nameof(this.state.searchParams.fechaCompraFrom)}
                        value={this.state.searchParams.fechaCompraFrom}
                        yearsFront={2}
                        yearsBack={3}
                        onChange={(val) => {
                            var state = this._cloneStateForSetState();
                            state.searchParams.fechaCompraFrom = val;
                            this.setState(state, () => this._performSearch());
                        }}
                    />
                </FormGroup>
            </Col>

            <Col xs="12" md="6" lg="3">
                <FormGroup>
                    <Label for={nameof(this.state.searchParams.fechaCompraTo)}>
                        {I18n.Strings.pedidos.fechaCompraTo}
                    </Label>
                    <CustomDatePicker
                        key={nameof(this.state.searchParams.fechaCompraTo)}
                        value={this.state.searchParams.fechaCompraTo}
                        yearsFront={2}
                        yearsBack={3}
                        onChange={(val) => {
                            var state = this._cloneStateForSetState();
                            state.searchParams.fechaCompraTo = val;
                            this.setState(state, () => this._performSearch());
                        }}
                    />
                </FormGroup>
            </Col>

        </React.Fragment>;
    }


    protected _getTableColumns(): TableColumn<PedidoLineaTiendaListItem>[] {

        let columns = [

            {
                fieldName: nameof(this.state.searchResults.items[0].numPedido),
                title: I18n.Strings.pedidos.numPedido,
                renderField: (item) => item.numPedido
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].nombreCliente),
                title: I18n.Strings.pedidos.cliente,
                renderField: (item) => item.nombreCliente
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].estudiante),
                title: I18n.Strings.pedidosLineas.estudiante,
                renderField: (item) => item.estudiante
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].clase),
                title: I18n.Strings.pedidosLineas.clase + "(material)",
                renderField: (item) => item.clase
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].cursoAlumno),
                title: I18n.Strings.pedidosLineas.cursoAlumno,
                renderField: (item) => item.cursoAlumno
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].fechaPedido),
                title: I18n.Strings.pedidos.fechaCompra,
                renderField: (item) => I18n.Strings.formatDateTime(item.fechaPedido)
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].isbn),
                title: I18n.Strings.pedidosLineas.isbn,
                renderField: (item) => item.isbn
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].titulo),
                title: I18n.Strings.pedidosLineas.titulo,
                renderField: (item) => item.titulo
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].unidades),
                title: I18n.Strings.pedidosLineas.numUnidades,
                renderField: (item) => item.unidades
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].estadoPedidoScholarum),
                title: I18n.Strings.pedidos.estado,
                renderField: (item) => I18n.Strings.getEnumText(`EstadoPedidoScholarum.${item.estadoPedidoScholarum}`)
            }
        ] as TableColumn<PedidoLineaTiendaListItem>[];


        if (
            ClientContext.Current.tipoUsuario == TipoUsuario.AdminGlobal ||
            ClientContext.Current.tipoUsuario == TipoUsuario.AdminInstitucion ||
            ClientContext.Current.tipoUsuario == TipoUsuario.VisorPedidos
        ) {
            columns.unshift({
                fieldName: nameof(this.state.searchResults.items[0].colegio),
                title: toCamelCase(I18n.Strings.colegio.entityName),
                renderField: (item) => item.colegio
            });
        }

        return columns;
    }


    protected _getPageTitle(): string {
        return I18n.Strings.pedidosLineas.title;
    }
    protected _getPageDescription(): string {
        return I18n.Strings.pedidosLineas.description;
    }

    protected _getNewItemUrl(): string {
        return null;
    }

    protected _getEditionItemUrl(item: PedidoLineaTiendaListItem): string {
        return RouteHelper.detallePedidoTienda(item.pedidoId);
    }

}

export const Index = withRouter(IndexComp);
